@if (authService.isAuthenticated()) {
  <div
    class="guscio"
    [class.guscio--compressa]="navigazione.compressa()"
    [class.guscio--menu-aperto]="navigazione.apertaSuMobile()"
  >
    <app-sidebar class="guscio__laterale" />

    <!-- Velo del pannello su schermo stretto: toccarlo fuori lo chiude. -->
    <button
      type="button"
      class="guscio__velo-menu"
      tabindex="-1"
      aria-label="Chiudi il menu"
      (click)="navigazione.chiudiMobile()"
    ></button>

    <div class="guscio__principale">
      <app-topbar />
      <main class="guscio__corpo">
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <main class="guscio__corpo guscio__corpo--nudo">
    <router-outlet />
  </main>
}

<app-back-to-top />

<!--
  Velo che blocca la pagina. Ora compare solo per le attese volute: le
  scritture, e in seguito le generazioni AI e i caricamenti. Le letture si
  limitano alla barra sottile in cima.
-->
@if (caricamento.bloccoAttivo()) {
  <div class="velo" role="status" aria-live="polite">
    <app-loader />
    <p class="velo__messaggio">{{ caricamento.messaggio() ?? 'Operazione in corso…' }}</p>
  </div>
}
